import { forwardRef, KeyboardEvent } from 'react';
import Tabicon from '../TabIcon/TabIcon';
import { Theme } from '../../../types/enums';
import { SelectorType, TabDesign } from '../types/enums';
import { filterTabIconTheme } from '../../utils/ThemeFilter/ThemeFilter';
import { TabProps, TabTheme } from './type/propsType';
import styles from './Tab.module.scss';

const Tab = forwardRef<HTMLDivElement, TabProps>((props: TabProps, ref) => {
  const {
    theme = Theme.BLACK,
    title,
    icon,
    iconStyle,
    selected = false,
    layout,
    design,
    onTabClick,
    selectorType,
    disabled = false,
    className = '',
    dataTabScrollId,
    tabIndex,
    onKeyDown,
    ...restProps
  } = props;

  const updatedSelectorType =
    design === TabDesign.PILL ? SelectorType.CIRCLE : icon ? selectorType : SelectorType.UNDERLINE;

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
      e.preventDefault();
      onTabClick?.();
    }

    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return (
    <div
      role="tab"
      aria-selected={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : tabIndex}
      onKeyDown={handleKeyDown}
      onClick={() => !disabled && onTabClick?.()}
      className={`${styles['tab-container']}  ${styles[theme]} ${styles[design]}
       ${disabled ? styles['disabled'] : ''} ${design !== TabDesign.ICON_CIRCLE ? styles[updatedSelectorType] : ''} ${
         styles[selected ? 'selected' : '']
       } ${className}`}
      data-testid="tab-container-test-id"
      data-tab-scroll-id={dataTabScrollId}
      ref={ref}
      {...restProps}
    >
      <div
        className={`${styles['tab-container-icon']} ${styles[layout]} ${disabled ? styles['disabled'] : ''} ${
          selected ? styles['selected'] : ''
        } ${styles[icon ? 'tab-title-mobile' : '']}`}
      >
        <Tabicon
          design={design}
          icon={icon}
          iconStyle={iconStyle}
          iconClass={styles['icon']}
          theme={theme && filterTabIconTheme(theme)}
          selected={selected}
          disabled={disabled}
          selectorType={design !== TabDesign.PILL ? updatedSelectorType : SelectorType.UNDERLINE}
        />
        <span className={`${styles['tab-title']} ${selected && !disabled ? styles['selected'] : ''}`}>{title}</span>
      </div>
      {selected && updatedSelectorType === SelectorType.UNDERLINE && (
        <div
          className={`${styles[theme]} ${design === TabDesign.SOLID ? styles[TabDesign.SOLID] : ''} ${
            styles['underline-container']
          }`}
        ></div>
      )}
    </div>
  );
});

Tab.displayName = 'Tab';

export default Tab;
export type { TabTheme };
